import React from 'react';
import { AddressFields } from '../../../../../../components/address/AddressFields';

/**
 * Where the company is billed.
 *
 * Uses the shared address block instead of the four free-text boxes of the
 * legacy form. Beyond the obvious typo-proofing, the commune it produces is the
 * catalog's own system name — the exact form the backend normalizes to before
 * storing — and that value is what a shipping zone's coverage is matched
 * against later.
 *
 * @param {object} props
 * @param {string} props.country - ISO2 of the account
 * @param {object} props.form
 * @param {(patch: object) => void} props.onChange
 * @param {Object.<string, string>} props.errors
 */
export const AddressStep = ({ country, form, onChange, errors }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
    <AddressFields country={country} value={form} onChange={onChange} errors={errors} />
  </div>
);
